import PropTypes from "prop-types";
import * as React from "react";
import { useCurrentUser } from "../../../globalState";
import { Dialog, Tabs } from "../../../themeV2";
import AdvancedSettingsContent from "./AdvancedSettingsContent";
import AffiliateLinksContent from "./AffiliateLinksContent";
import CategoriesContent from "./CategoriesContent";
import ProfileContent from "./ProfileContent";
import SalespersonsContent from "./SalespersonsContent";
import ServicesContent from "./ServicesContent";
import styles from "./ShopSettingsDialog.module.css";

const ShopSettingsDialog = React.memo(function ShopSettingsDialog({
  route,
  influencer,
  influencerId,
  onClose,
}) {
  const currentUser = useCurrentUser();

  return (
    <Dialog.Root open onOpenChange={(open) => !open && onClose()}>
      <Dialog.Popup size="lg" align="top">
        <Dialog.Title>Shop settings</Dialog.Title>
        <Dialog.Close />

        <Dialog.Tabs defaultValue="profile">
          <Dialog.TabsList>
            <Tabs.Tab value="profile">Profile</Tabs.Tab>
            {currentUser.isAdmin && (
              <Tabs.Tab value="categories">Categories</Tabs.Tab>
            )}
            {currentUser.isAdmin && !influencer.group_shop && (
              <Tabs.Tab value="salespersons">Salespersons</Tabs.Tab>
            )}
            {currentUser.isAdmin && !influencer.group_shop && (
              <Tabs.Tab value="affiliateLinks">Affiliate Links</Tabs.Tab>
            )}
            {!influencer.group_shop && (
              <Tabs.Tab value="services">Services</Tabs.Tab>
            )}
            {currentUser.isAdmin && (
              <Tabs.Tab value="advanced">Advanced</Tabs.Tab>
            )}
          </Dialog.TabsList>

          <Dialog.Body>
            <Tabs.Panel value="profile" className={styles.tabContent}>
              <ProfileContent
                route={route}
                influencer={influencer}
                onClose={onClose}
              />
            </Tabs.Panel>

            {currentUser.isAdmin && (
              <Tabs.Panel value="categories" className={styles.tabContent}>
                <CategoriesContent influencerId={influencerId} />
              </Tabs.Panel>
            )}

            {currentUser.isAdmin && !influencer.group_shop && (
              <Tabs.Panel value="salespersons" className={styles.tabContent}>
                <SalespersonsContent influencerId={influencerId} />
              </Tabs.Panel>
            )}

            {currentUser.isAdmin && !influencer.group_shop && (
              <Tabs.Panel value="affiliateLinks" className={styles.tabContent}>
                <AffiliateLinksContent
                  influencerId={influencerId}
                  influencerRoute={influencer.route}
                />
              </Tabs.Panel>
            )}

            {!influencer.group_shop && (
              <Tabs.Panel value="services" className={styles.tabContent}>
                <ServicesContent
                  influencerId={influencerId}
                  readOnly={!currentUser.isAdmin}
                />
              </Tabs.Panel>
            )}

            {currentUser.isAdmin && (
              <Tabs.Panel value="advanced" className={styles.tabContent}>
                <AdvancedSettingsContent
                  influencer={influencer}
                  onClose={onClose}
                />
              </Tabs.Panel>
            )}
          </Dialog.Body>
        </Dialog.Tabs>
      </Dialog.Popup>
    </Dialog.Root>
  );
});

ShopSettingsDialog.propTypes = {
  route: PropTypes.string.isRequired,
  influencer: PropTypes.object.isRequired,
  influencerId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ShopSettingsDialog;
